module.exports = __webpack_public_path__ + "img/footer2.b431fac9.png";